const numberFormatter = (n) =>
  ((Math.log10(n) / 3) | 0) === 0
    ? n
    : Number((n / Math.pow(10, ((Math.log10(n) / 3) | 0) * 3)).toFixed(1)) +
      ["", "K", "M", "B", "T"][(Math.log10(n) / 3) | 0];

export default numberFormatter;
